module.exports = __webpack_public_path__ + "img/icone_pdf.f0fb83fc.png";